import {
  detectCountryFromCoordinates,
  hasOwnMap,
  OWN_MAP_DATA_COUNTRIES,
} from "../../../../shared/countryDetection";
// COUNTRY_MAPS + Karten-Hilfen stammen aus der geteilten Registry, damit Web und
// Mobile (client/lib/countryMaps.ts) garantiert identische Karten/Deep-Links
// verwenden. Siehe shared/countryMaps.ts.
import {
  COUNTRY_MAPS,
  EASA_FALLBACK_MAP,
  buildMapUrl,
  getCountryMapConfig,
  getMapConfigOrFallback,
} from "../../../../shared/countryMaps";
import type { CountryMapConfig } from "../../../../shared/countryMaps";

export { detectCountryFromCoordinates, hasOwnMap, OWN_MAP_DATA_COUNTRIES };
export { COUNTRY_MAPS, EASA_FALLBACK_MAP, buildMapUrl, getCountryMapConfig, getMapConfigOrFallback };
export type { CountryMapConfig };

type BundeslandBBox = {
  name: string;
  minLat: number;
  maxLat: number;
  minLon: number;
  maxLon: number;
  priority: number;
};

const BUNDESLAND_BBOXES: BundeslandBBox[] = [
  { name: "Berlin", minLat: 52.34, maxLat: 52.68, minLon: 13.09, maxLon: 13.76, priority: 1 },
  { name: "Hamburg", minLat: 53.39, maxLat: 53.74, minLon: 9.73, maxLon: 10.33, priority: 1 },
  { name: "Bremen", minLat: 53.01, maxLat: 53.61, minLon: 8.48, maxLon: 8.99, priority: 1 },
  { name: "Saarland", minLat: 49.11, maxLat: 49.64, minLon: 6.36, maxLon: 7.41, priority: 2 },
  { name: "Thüringen", minLat: 50.20, maxLat: 51.65, minLon: 9.88, maxLon: 12.65, priority: 3 },
  { name: "Sachsen", minLat: 50.17, maxLat: 51.68, minLon: 11.87, maxLon: 15.04, priority: 3 },
  { name: "Sachsen-Anhalt", minLat: 50.94, maxLat: 53.04, minLon: 10.56, maxLon: 13.19, priority: 3 },
  { name: "Schleswig-Holstein", minLat: 53.36, maxLat: 55.06, minLon: 7.87, maxLon: 11.35, priority: 3 },
  { name: "Mecklenburg-Vorpommern", minLat: 53.11, maxLat: 54.68, minLon: 10.59, maxLon: 14.41, priority: 3 },
  { name: "Hessen", minLat: 49.39, maxLat: 51.66, minLon: 7.77, maxLon: 10.24, priority: 3 },
  { name: "Rheinland-Pfalz", minLat: 48.97, maxLat: 50.94, minLon: 6.11, maxLon: 8.51, priority: 3 },
  { name: "Baden-Württemberg", minLat: 47.53, maxLat: 49.79, minLon: 7.51, maxLon: 10.50, priority: 4 },
  { name: "Bayern", minLat: 47.27, maxLat: 50.56, minLon: 8.98, maxLon: 13.84, priority: 4 },
  { name: "Nordrhein-Westfalen", minLat: 50.32, maxLat: 52.53, minLon: 5.87, maxLon: 9.46, priority: 4 },
  { name: "Niedersachsen", minLat: 51.30, maxLat: 53.89, minLon: 6.65, maxLon: 11.60, priority: 5 },
  { name: "Brandenburg", minLat: 51.36, maxLat: 53.56, minLon: 11.27, maxLon: 14.77, priority: 5 },
];

export function detectBundeslandFromCoordinates(lat: number, lon: number): string | null {
  const matches = BUNDESLAND_BBOXES.filter(
    (b) => lat >= b.minLat && lat <= b.maxLat && lon >= b.minLon && lon <= b.maxLon,
  );
  if (matches.length === 0) return null;
  matches.sort((a, b) => a.priority - b.priority);
  if (matches.length === 1) return matches[0].name;

  const cityState = matches.find((m) => m.priority === 1);
  if (cityState) return cityState.name;

  let best = matches[0];
  let bestArea = (best.maxLat - best.minLat) * (best.maxLon - best.minLon);
  for (let i = 1; i < matches.length; i++) {
    const area = (matches[i].maxLat - matches[i].minLat) * (matches[i].maxLon - matches[i].minLon);
    if (area < bestArea) {
      best = matches[i];
      bestArea = area;
    }
  }
  return best.name;
}
